import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setActiveLink(window.location.pathname);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  const navItems = [
    { href: '/', label: 'Home' },
    { href: '/listings', label: 'Properties' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      {/* Amber accent bar at top */}
      <div className="navbar-accent-bar" />

      <div className="navbar-container">
        {/* Logo */}
        <a href="/" className="logo" onClick={closeMobileMenu}>
          <span className="logo-vetri">VETRI</span>
          <span className="logo-realtors">REALTORS</span>
          <span className="logo-dot" />
        </a>

        {/* Desktop nav */}
        <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
          {navItems.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className={`nav-link ${activeLink === href ? 'nav-link--active' : ''}`}
              onClick={() => { setActiveLink(href); closeMobileMenu(); }}
            >
              {label}
              <span className="nav-link-bar" />
            </a>
          ))}

          {/* Mobile-only CTA */}
          <a href="tel:+918438623133" className="phone-button phone-button--mobile">
            <i className="fas fa-phone-alt" />
            <span>+91 84386 23133</span>
          </a>
        </div>

        {/* Desktop CTA */}
        <a href="tel:+918438623133" className="phone-button">
          <i className="fas fa-phone-alt" />
          <span className="phone-text">Call Us Now</span>
        </a>

        {/* Hamburger */}
        <button
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <div className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
            <span />
            <span />
            <span />
          </div>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu-backdrop" onClick={closeMobileMenu} />
      )}
    </nav>
  );
};

export default Navbar;